import { commonMessages } from "@/i18n/messages/common";
import { dataMessages } from "@/i18n/messages/data";
import { operationsMessages } from "@/i18n/messages/operations";
import { calendarMessages } from "@/i18n/messages/calendar";
import { adminMessages } from "@/i18n/messages/admin";
import { insightsMessages } from "@/i18n/messages/insights";
import { createCatalogRegistry, interpolate, normalizeLanguage } from "@/i18n/core";

const registry = createCatalogRegistry([
  commonMessages,
  dataMessages,
  operationsMessages,
  calendarMessages,
  adminMessages,
  insightsMessages,
]);
const missing = new Set();

export function translateKey(key, params = {}, language = "en") {
  if (key === null || key === undefined) return "";
  if (typeof key !== "string") return key;
  const message = registry.messages[key];
  if (!message) {
    if (process.env.NODE_ENV !== "production" && !missing.has(key)) {
      missing.add(key);
      console.warn(`[i18n] Missing catalog key: ${key}`);
    }
    return interpolate(key, params);
  }
  return interpolate(message[normalizeLanguage(language)], params);
}

export function localizeCatalogSource(source, params = {}, language = "en") {
  if (source === null || source === undefined) return "";
  if (typeof source !== "string") return source;
  const key = registry.sourceKeys[source];
  if (key) return translateKey(key, params, language);
  for (const pattern of registry.sourcePatterns) {
    const match = source.match(pattern.regex);
    if (!match) continue;
    const sourceParams = Object.fromEntries(pattern.names.map((name, index) => {
      const captured = match[index + 1];
      const capturedKey = registry.sourceKeys[captured];
      return [name, capturedKey ? translateKey(capturedKey, {}, language) : captured];
    }));
    return translateKey(pattern.key, { ...sourceParams, ...params }, language);
  }
  return interpolate(source, params);
}
